import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import LoginPanel from "../containers/LoginPanel";

export default function PrivateRoute({
  redirect,
  component,
  isAuthenticated,
  ...rest
}: any) {
  const routeComponent = ({ ...props }) =>
    isAuthenticated ? (
      React.createElement(component, props)
    ) : window.location.search.includes("logout=true") ? (
      <Redirect to={redirect} />
    ) : (
      <div style={{ height: window.innerHeight - 550 }}>
        <LoginPanel closeRedirect={redirect} />
      </div>
    );
  return <Route {...rest} render={routeComponent} />;
}
